import { SP } from '../../lib/shareTokens'

interface Props {
  imageUrl?: string
  gradient?: string
  height?: number
  children?: React.ReactNode
}

const FALLBACK_GRADIENT = 'linear-gradient(135deg, #F7C08A 0%, #EF606A 45%, #251884 100%)'
const STRIPE_OVERLAY = 'repeating-linear-gradient(45deg, rgba(255,255,255,0.07) 0 1px, transparent 1px 14px)'

export default function Hero({ imageUrl, gradient, height = 380, children }: Props) {
  return (
    <div style={{ position: 'relative', width: '100%', height, overflow: 'hidden' }}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt=""
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <>
          <div style={{
            position: 'absolute',
            inset: 0,
            background: gradient ?? FALLBACK_GRADIENT,
          }} />
          <div style={{ position: 'absolute', inset: 0, backgroundImage: STRIPE_OVERLAY }} />
        </>
      )}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(12,12,12,0.1) 45%, rgba(12,12,12,0.95) 100%)',
      }} />
      <div style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 4,
        background: SP.lime,
        boxShadow: `0 0 24px ${SP.lime}`,
      }} />
      {children}
    </div>
  )
}
